export default __webpack_public_path__ + "static/media/BgGroup38295.5a9b7067.png";